import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CompareState, compareFeatureKey } from './compare.reducer';

export const selectInstitutionsStoreState = createFeatureSelector<CompareState>(compareFeatureKey);

export const selectInstitutions = createSelector(
  selectInstitutionsStoreState,
  (state) => state.institutions || []
);

export const selectInstitutionsInCompare = createSelector(
  selectInstitutionsStoreState,
  (state) => state.institutionsInCompare || []
);
